import { Box, Button, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AutoToggleAccordion } from "lib/@components/auto-toggle-accordion"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { LEADING_SUMMARY_AMENDS_KEY } from "authoring/routes/project/amends/lib/constants/amends-keys"
import { InlineCompareButtons } from "routes/schedule/compare/inline-approval-buttons/inline-compare-buttons"
import { Bound } from "lib/@components/binding/Bound"
import { AmendsBoundaryEditor } from "../amends/components/amends-boundary-editor"
import { AuthoringReviewPriorRejection } from "./authoring-review-prior-rejection"

export function AuthoringReviewLeadingSummary() {
    const { amendsContext, target, comparisonTarget } = useBoundContext()
    if (!amendsContext) return null

    const amendsState = amendsContext.getAmendsState(LEADING_SUMMARY_AMENDS_KEY)
    if (!amendsState) return null

    const { isOpen, canEdit } = amendsState

    if (!isOpen && !canEdit) return null

    return (
        <AutoToggleAccordion
            summaryContent={
                <Typography variant="subtitle1" data-cy="authoring-review-leading-summary-title">
                    Leading Summary
                </Typography>
            }
            detailsContent={
                <Box sx={{ pt: 1 }}>
                    <If value={isOpen}>
                        <Stack spacing={1}>
                            <AmendsBoundaryEditor
                                amendsKey={LEADING_SUMMARY_AMENDS_KEY}
                                autoFocusOnOpen={false}
                                subtitle="Leading Summary"
                            />
                            <AuthoringReviewPriorRejection amendsKey={LEADING_SUMMARY_AMENDS_KEY} />
                            <Bound acceptId={LEADING_SUMMARY_AMENDS_KEY} groupReviewId={target?.groupReviewId}>
                                <Box data-cy="authoring-review-leading-summary-decision">
                                    <InlineCompareButtons
                                        idFromGroup={LEADING_SUMMARY_AMENDS_KEY}
                                        to={target}
                                        from={comparisonTarget}
                                    />
                                </Box>
                            </Bound>
                        </Stack>
                        <Else>
                            <Button variant="outlined" size="small" onClick={openEditor}>
                                Add Leading Summary
                            </Button>
                        </Else>
                    </If>
                </Box>
            }
            sx={{ backgroundColor: "" }}
            titleSx={{ backgroundColor: "" }}
        />
    )

    function openEditor() {
        amendsContext.onOpenAmends(LEADING_SUMMARY_AMENDS_KEY)
    }
}
